import {
  ProductCardProps,
  QuickshopButtonGridProps,
  QuickshopDrawerProps,
} from "@made-people/blueprint-product-card";
import { MMProductDeliveryStatus } from "../../features/delivery-status/mm-product-delivery-status";
import { AlgoliaCentraProductWrapper } from "../../features/delivery-status/algolia-centra-product-wrapper";
import { SizeGuideTrigger } from "../../features/size-guide";
import { Cross } from "../../../assets/icons/Cross";
import { DISCOUNT_BADGES_ENABLED } from "../../../config/discount-badges";

/**
 * In this file you can specify default props for components that render,
 * which have been wrapped with withManagedProps
 */

export const ProductCard: ProductCardProps = {
  templateProps: {
    template: "1",
    swatches: {
      productSwatchAttribute: "product_color_image_url",
      placeIn: "details",
      maxSwatches: 4,
    },
    quickshop: {
      details: {
        configs: [],
      },
      gallery: {
        configs: [
          {
            config: {
              sizesCount: {
                from: 0,
                to: 20,
              },
              optionsCount: {
                from: 1,
                to: 10,
              },
            },
            template: {
              template: "drawer",
              aboveAddToCartButtonComponent: <MMProductDeliveryStatus />,
              belowAddToCartButtonComponent: (
                <SizeGuideTrigger className="justify-center mt-2" />
              ),
              wrapper: AlgoliaCentraProductWrapper,
              variants: {
                placeIn: "gallery",
              },
              oneSizeButton: {
                variants: {
                  color: "white",
                  rounded: "none",
                  width: "same-as-height",
                  size: "xs",
                },
              },
            },
          },
        ],
      },
    },
    badges: {
      location: "gallery",
      showWithDiscount: false,
      discountBadge: {
        enabled: DISCOUNT_BADGES_ENABLED,
        variants: {
          size: "md",
          color: "red",
        },
      },
    },
    productInfoText: {
      attributeKey: "wiring",
    },
    details: {
      variants: {
        spacing: "false",
      },
    },
    gallery: {
      imageSettings: {
        displaySize: {
          mobile: "50vw",
          tablet: "25vw",
          desktop: "17vw",
        },
        processingOptions: {
          quality: 75,
        },
      },
    },
  },
} satisfies ProductCardProps;

export const QuickshopDrawer = {
  template: "drawer",
  displayHeading: false,
  postAddAction: "showMinicart",
  alwaysDisplayAddToCartButton: true,
  aboveAddToCartButtonComponent: <MMProductDeliveryStatus />,
  belowAddToCartButtonComponent: (
    <SizeGuideTrigger className="justify-center mt-2" />
  ),
  wrapper: AlgoliaCentraProductWrapper,
  drawerSettings: {
    header: {
      closeIcon: <Cross className="w-4 h-4" />,
    },
  },
  buttons: {
    variants: {
      rounded: "full",
      width: "same-as-height",
      size: "md",
      color: "black",
      style: "outline",
    },
  },
  trigger: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5"
      viewBox="0 0 15 17"
    >
      <path d="M12.92 17H2.08a2 2 0 0 1-.83-.18 1.92 1.92 0 0 1-.7-.5 2.06 2.06 0 0 1-.54-1.59L.7 6a1.3 1.3 0 0 1 .41-.85 1.26 1.26 0 0 1 .88-.35h1.84V3.7a3.66 3.66 0 0 1 6.27-2.61 3.67 3.67 0 0 1 1.07 2.61v1.1h1.84a1.26 1.26 0 0 1 .88.35 1.3 1.3 0 0 1 .41.85l.69 8.73a2.08 2.08 0 0 1-.1.86 2.26 2.26 0 0 1-.44.73 1.92 1.92 0 0 1-.7.5 2 2 0 0 1-.83.18zM1.99 5.8a.32.32 0 0 0-.2.08.29.29 0 0 0-.09.2L1 14.81a1.17 1.17 0 0 0 .06.45 1.09 1.09 0 0 0 .23.39 1 1 0 0 0 .36.26 1.11 1.11 0 0 0 .43.09h10.84a1.07 1.07 0 0 0 .43-.09 1 1 0 0 0 .36-.26 1.18 1.18 0 0 0 .23-.39 1.14 1.14 0 0 0 .06-.45l-.7-8.73a.29.29 0 0 0-.09-.2.32.32 0 0 0-.2-.08h-1.84v1.9a.5.5 0 0 1-1 0V5.8H4.83v1.9a.5.5 0 0 1-1 0V5.8zm-.79.24zM7.5 1a2.66 2.66 0 0 0-1.89.79 2.72 2.72 0 0 0-.78 1.91v1.1h5.34V3.7A2.68 2.68 0 0 0 7.5 1z" />
    </svg>
  ),
} satisfies QuickshopDrawerProps;

export const ProductCardQuickshopButtonGrid = {
  buttons: {
    variants: {
      color: "black",
      size: "sm",
      width: "auto",
      style: "outline",
    },
    hoverEffect: false,
  },
} satisfies Omit<QuickshopButtonGridProps, "template">;
